import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
	selector: 'app-forgot-password',
	templateUrl: './forgot-password.page.html',
	styleUrl: './forgot-password.page.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotPasswordPage {
	public resetForm: FormGroup;
	private readonly onDestroy$ = new Subject<void>();

	constructor(
		private fb: FormBuilder,
		private navService: NavigationService,
		private apiService: ApiService,
		private snackbar: SnackbarService,
		private translate: TranslateService
	) {
		this.resetForm = this.fb.group({
			email: ['', [Validators.required, Validators.email]],
		});
	}

	ngOnDestroy() {
		this.onDestroy$.next();
	}

	onSubmit() {
		if (this.resetForm.invalid) return;
		const email = this.resetForm.value.email;

		this.apiService
			.forgotPassword(email)
			.pipe(takeUntil(this.onDestroy$))
			.subscribe({
				next: () => {
					this.snackbar.showSuccess(this.translate.instant('forgot_page.check_email'), 7000);
				},
				error: () => {
					this.snackbar.showError(this.translate.instant('forgot_page.error'), 4000);
				},
			});
	}

	goToLogin() {
		this.navService.login();
	}
}
